import { Observable, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressPaging } from '@app/enums/_index';
import { CMSSubscriptionInterface } from '@app/interfaces/_index';
import { getCacheBustedParams } from '@app/utilities/_index';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class WordpressSubscriptionsService extends ErrorHandlerService {
  private subscriptionsUrl = `${environment.cms.url}/wp-json/wp/v2/subscription`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Return subscription details
   * @returns - returns a observable array of subscriptions
   */
  getSubscriptionList(): Observable<CMSSubscriptionInterface[]> {
    const subscriptionURLParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);
    return this.http
      .get<CMSSubscriptionInterface[]>(`${this.subscriptionsUrl}`, {
        params: subscriptionURLParams,
      })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<CMSSubscriptionInterface[]>('getSubscriptionList', []))
      );
  }

  /**
   * Return subscription details based on slug
   * @param slug - string that pulls subscription details
   * @returns - returns a observable array of subscriptions
   */
  getSubscriptionBySlug(slug: string): Observable<CMSSubscriptionInterface[]> {
    const subscriptionURLParams = getCacheBustedParams()
      .append(WordpressPaging.ORDER_BY_KEY, WordpressPaging.ORDER_BY_VALUE)
      .append(WordpressPaging.ORDER_KEY, WordpressPaging.ORDER_VALUE)
      .append(WordpressPaging.PER_PAGE_KEY, WordpressPaging.PER_PAGE_VALUE);
    return this.http
      .get<CMSSubscriptionInterface[]>(`${this.subscriptionsUrl}?slug=${slug}`, {
        params: subscriptionURLParams,
      })
      .pipe(
        catchError((err) => {
          console.log(`Service error has occurred`, err);
          return throwError(() => new Error(err));
        }),
        catchError(this.handleError<CMSSubscriptionInterface[]>('getSubscriptionBySlug', []))
      );
  }
}
